const translations = {
  en: {
    // Navigation
    nav_login: "Log In",
    nav_get_started: "Get Started",
    nav_dashboard: "Dashboard",
    nav_journal: "Journal",
    nav_chat: "Chat",
    nav_insights: "Insights",
    nav_analytics: "Analytics",
    nav_notes: "All Notes",
    nav_signout: "Sign Out",
    nav_signed_as: "Signed in as",
    nav_mood: "Mood",
    nav_admin: "Admin Panel",
    nav_back_to_app: "Back to App",

    // Landing Page
    hero_title_1: "Your Mind,",
    hero_title_2: "Understood",
    hero_subtitle: "Smart digital journaling for mental wellness. Track your mood, detect emotional patterns, and get personalized recommendations.",
    hero_cta: "Start Your Journey",
    hero_learn_more: "Learn More",
    features_title: "Key Features",
    features_subtitle: "Everything you need for better mental wellness",
    feature_input: "Flexible Input",
    feature_input_desc: "Text, voice, video or prompts that encourage reflection",
    feature_coach: "Smart Coach",
    feature_coach_desc: "Personalized recommendations based on your history",
    feature_analytics: "Visual Analytics",
    feature_analytics_desc: "Mood trends, emotional patterns, weekly insights",
    feature_privacy: "Complete Privacy",
    feature_privacy_desc: "End-to-end encrypted entries",
    feature_insights: "Real-Time Insights",
    feature_insights_desc: "Detect triggers and stress patterns as they emerge",
    feature_availability: "24/7 Availability",
    feature_availability_desc: "Available anywhere, anytime",
    benefits_title: "Proven Benefits",
    benefits_subtitle: "Research-backed results for your well-being",
    benefit_1: "Reduction in anxiety after 8 weeks (NCBI study)",
    benefit_2: "Improvement in depressive symptoms after 12 weeks",
    benefit_3: "Retention rate after 3 months",
    benefit_4: "Time between entry and insight",
    cta_title: "Ready for the",
    cta_title_2: "Beta",
    cta_subtitle: "Join our beta program and be among the first to experience VerbNotes.",
    cta_placeholder: "Enter your email",
    cta_button: "Join Beta",
    cta_signing: "Signing up...",
    footer_privacy: "Privacy",
    footer_terms: "Terms",
    footer_contact: "Contact",

    // Auth Pages
    login_title: "Welcome Back",
    login_subtitle: "Sign in to continue your journey",
    login_email: "Email",
    login_password: "Password",
    login_button: "Sign In",
    login_signing: "Signing in...",
    login_no_account: "Don't have an account?",
    login_create: "Create one",
    login_2fa_code: "2FA Code",
    login_2fa_prompt: "Enter your authenticator code",
    login_social: "Or continue with",
    register_title: "Create Account",
    register_subtitle: "Start your wellness journey today",
    register_name: "Full Name",
    register_button: "Create Account",
    register_creating: "Creating account...",
    register_has_account: "Already have an account?",
    register_signin: "Sign in",
    password_length: "At least 8 characters",
    password_number: "Contains a number",

    // Dashboard
    dashboard_greeting_morning: "Good morning",
    dashboard_greeting_afternoon: "Good afternoon",
    dashboard_greeting_evening: "Good evening",
    dashboard_overview: "Here's your wellness overview",
    dashboard_new_entry: "New Journal Entry",
    dashboard_new_entry_desc: "Write or record your thoughts",
    dashboard_chat: "Chat with Wellness Coach",
    dashboard_chat_desc: "Get personalized support",
    dashboard_avg_mood: "Avg Mood",
    dashboard_total_notes: "Total Notes",
    dashboard_streak: "Streak",
    dashboard_progress: "Progress",
    dashboard_days: "days",
    dashboard_recent: "Recent Notes",
    dashboard_view_all: "View all",
    dashboard_no_notes: "No notes yet. Start journaling!",
    dashboard_insights: "Smart Insights",
    dashboard_no_insights: "Add more notes to unlock insights!",

    // Mood Trend Widget
    mood_trend_title: "7-Day Mood Trend",
    mood_trend_empty: "No mood data this week. Start checking in daily!",

    // Journal
    journal_title: "Journal",
    journal_subtitle: "Express your thoughts through text, voice, or video",
    journal_feeling: "How are you feeling?",
    journal_mood_verylow: "Very Low",
    journal_mood_low: "Low",
    journal_mood_neutral: "Neutral",
    journal_mood_good: "Good",
    journal_mood_great: "Great",
    journal_tab_text: "Text",
    journal_tab_voice: "Voice",
    journal_tab_video: "Video",
    journal_placeholder: "What's on your mind? Write freely without judgment...",
    journal_characters: "characters",
    journal_save: "Save Entry",
    journal_record: "Tap to start recording",
    journal_recording: "Recording... Tap to stop",
    journal_ready: "Recording ready! Submit or record again",
    journal_transcribe: "Transcribe & Save",
    journal_processing: "Processing...",
    journal_saved: "Just Saved",
    journal_video_record: "Record Video",
    journal_video_upload: "Upload Video",
    journal_video_recording: "Recording video... Tap to stop",
    journal_video_ready: "Video ready! Submit or record again",
    journal_video_processing: "Processing video...",
    journal_video_or: "or",

    // Chat
    chat_title: "Wellness Coach",
    chat_subtitle: "Your supportive wellness companion",
    chat_welcome: "Hi there! I'm your VerbNotes Wellness Coach. I'm here to listen and help you reflect on your thoughts and feelings. How are you doing today?",
    chat_cleared: "Chat cleared! I'm ready to start fresh. What's on your mind?",
    chat_placeholder: "Type your message...",
    chat_save_insight: "Save insight to journal",
    chat_history: "Chat History",
    chat_history_subtitle: "Browse and search your past conversations",
    chat_search_placeholder: "Search conversations...",
    chat_no_history: "No conversations yet. Start chatting with your Wellness Coach!",
    chat_new_chat: "New Chat",
    chat_sessions: "Sessions",
    chat_view_session: "View",
    chat_delete_session: "Delete",

    // Insights
    insights_title: "Smart Insights",
    insights_subtitle: "Personalized patterns and recommendations based on your entries",
    insights_empty_title: "No insights yet",
    insights_empty_desc: "Keep journaling to unlock personalized insights about your emotional patterns and well-being.",
    insights_emotional_patterns: "Emotional Patterns",
    insights_trending_up: "Trending upward",
    insights_trending_down: "Trending downward",
    insights_stable: "Stable",
    insights_positive: "positive",
    insights_negative: "negative",
    insights_neutral: "neutral",
    insights_mentions: "mentions",
    insights_positive_entries: "positive entries",

    // Analytics
    analytics_title: "Analytics",
    analytics_subtitle: "Track your wellness journey with data-driven insights",
    analytics_avg_mood: "Avg Mood",
    analytics_total: "Total Notes",
    analytics_streak: "Streak",
    analytics_progress: "Progress",
    analytics_out_of: "out of 10",
    analytics_entries: "entries",
    analytics_days: "days",
    analytics_vs_week: "vs last week",
    analytics_mood_trend: "Mood Trend",
    analytics_sentiment: "Sentiment Distribution",
    analytics_topics: "Top Topics",
    analytics_no_mood: "No mood data yet",
    analytics_no_sentiment: "No sentiment data yet",

    // Notes
    notes_title: "All Notes",
    notes_entries: "entries",
    notes_search: "Search notes...",
    notes_all_types: "All Types",
    notes_text: "Text",
    notes_voice: "Voice",
    notes_video: "Video",
    notes_voice_note: "Voice Note",
    notes_text_entry: "Text Entry",
    notes_video_note: "Video Note",
    notes_mood: "Mood",
    notes_summary: "Summary",
    notes_empty_title: "No notes found",
    notes_empty_desc: "Start journaling to see your notes here",
    notes_empty_search: "Try a different search term",
    notes_delete_title: "Delete Note",
    notes_delete_desc: "Are you sure you want to delete this note? This action cannot be undone.",
    notes_cancel: "Cancel",
    notes_delete: "Delete",

    // Mood Tracker
    mood_checkin_title: "How are you feeling?",
    mood_checkin_subtitle: "Take a moment to check in with yourself",
    mood_awful: "Awful",
    mood_down: "Down",
    mood_okay: "Okay",
    mood_good: "Good",
    mood_great: "Great",
    mood_note_placeholder: "What's on your mind? (optional)",
    mood_submit: "Log & Analyze Mood",
    mood_analyzing: "Analyzing...",
    mood_logged: "Mood Logged",
    mood_ai_insight: "AI Insight",
    mood_suggestions: "Suggestions",
    mood_continue: "Continue to Dashboard",
    mood_tracker_title: "Mood Tracker",
    mood_tracker_subtitle: "Your emotional wellness journey",
    mood_avg: "Avg Mood",
    mood_total_checkins: "Total Check-ins",
    mood_streak: "Streak",
    mood_top_mood: "Top Mood",
    mood_distribution: "Mood Distribution",
    mood_recent: "Recent Check-ins",
    mood_no_checkins: "No mood check-ins yet. Your first check-in will appear here.",
    mood_prev: "Prev",
    mood_next: "Next",

    // Weekly Report
    mood_weekly_title: "Weekly Mood Report",
    mood_weekly_desc: "Receive an AI-generated summary of your weekly mood patterns every Monday via email.",
    mood_weekly_enabled: "Weekly report enabled",
    mood_weekly_disabled: "Weekly report disabled",
    mood_weekly_toggle_on: "Enable Weekly Report",
    mood_weekly_toggle_off: "Disable Weekly Report",
    mood_weekly_preview: "Preview Report",
    mood_weekly_no_data: "Not enough mood data for a report yet. Check in daily to build your history!",

    // Settings
    settings_title: "Settings",
    settings_preferences: "Preferences",
    settings_2fa_title: "Two-Factor Authentication",
    settings_2fa_desc: "Add an extra layer of security to your account using Google Authenticator.",
    settings_2fa_enabled: "2FA is enabled",
    settings_2fa_disabled: "2FA is not enabled",
    settings_2fa_setup: "Set Up 2FA",
    settings_2fa_disable: "Disable 2FA",
    settings_2fa_scan: "Scan this QR code with Google Authenticator",
    settings_2fa_enter_code: "Enter the 6-digit code from your app",
    settings_2fa_verify: "Verify & Enable",
    settings_subscription: "Subscription",
    settings_manage_sub: "Manage Subscription",
    settings_connected: "Connected Services",
    settings_connect: "Connect",
    settings_disconnect: "Disconnect",
    settings_connected_desc: "Connect external services to enhance your AI experience",

    // Pricing Page
    pricing_title: "Choose Your Plan",
    pricing_subtitle: "Start free, upgrade when you're ready",
    pricing_monthly: "Monthly",
    pricing_yearly: "Yearly",
    pricing_save: "Save",
    pricing_current: "Current Plan",
    pricing_upgrade: "Upgrade",
    pricing_downgrade: "Downgrade",
    pricing_get_started: "Get Started",
    pricing_per_month: "/month",
    pricing_per_year: "/year",
    pricing_one_time: "One-time payment",
    pricing_popular: "Most Popular",
    pricing_free_desc: "Perfect for getting started",
    pricing_basic_desc: "For regular journalers",
    pricing_premium_desc: "For serious self-improvement",
    pricing_lifetime_desc: "Best long-term value",

    // Contact Page
    contact_title: "Contact Us",
    contact_subtitle: "We'd love to hear from you. Send us a message!",
    contact_name: "Name",
    contact_name_placeholder: "Your name",
    contact_email: "Email",
    contact_email_placeholder: "your@email.com",
    contact_subject: "Subject",
    contact_subject_placeholder: "What's this about?",
    contact_message: "Message",
    contact_message_placeholder: "Tell us what's on your mind...",
    contact_send: "Send Message",
    contact_sending: "Sending...",
    contact_success: "Message sent successfully!",
    contact_error: "Please fill in all required fields.",
    contact_company: "Liber Nostra d.o.o.",
    contact_address: "Zagreb, Croatia",
    contact_back: "Back to Home",

    // Privacy Page
    privacy_title: "Privacy Policy",
    privacy_last_updated: "Last updated",
    privacy_intro: "VerbNotes (\"we\", \"us\", or \"our\") is committed to protecting your privacy. This policy explains how we collect, use, and safeguard your information.",
    privacy_collect_title: "Information We Collect",
    privacy_collect_desc: "We collect information you provide directly: account details (name, email), journal entries, mood data, voice recordings, and video recordings. We also collect usage data and device information automatically.",
    privacy_use_title: "How We Use Your Information",
    privacy_use_desc: "Your data is used to provide and improve our services, generate AI-powered insights, and personalize your experience. We never sell your personal data to third parties.",
    privacy_security_title: "Data Security",
    privacy_security_desc: "We implement industry-standard security measures to protect your data, including encryption in transit and at rest.",
    privacy_rights_title: "Your Rights",
    privacy_rights_desc: "You have the right to access, correct, or delete your personal data at any time. Contact us at support@verbnotes.com for any requests.",
    privacy_cookies_title: "Cookies",
    privacy_cookies_desc: "We use essential cookies for authentication and preferences. Analytics cookies are used only with your consent.",
    privacy_contact_title: "Contact",
    privacy_contact_desc: "For privacy-related inquiries, please contact us at support@verbnotes.com.",

    // Terms Page
    terms_title: "Terms of Service",
    terms_last_updated: "Last updated",
    terms_intro: "By using VerbNotes, you agree to these Terms of Service. Please read them carefully.",
    terms_use_title: "Use of Service",
    terms_use_desc: "VerbNotes provides AI-powered journaling and wellness tools. You must be at least 16 years old to use our service. You are responsible for maintaining the confidentiality of your account.",
    terms_content_title: "Your Content",
    terms_content_desc: "You retain ownership of all content you create. By using our service, you grant us a limited license to process your content for AI analysis and service delivery.",
    terms_ai_title: "AI Disclaimer",
    terms_ai_desc: "Our AI features provide general wellness suggestions and are not a substitute for professional medical or psychological advice. Always consult a healthcare professional for serious concerns.",
    terms_payment_title: "Payments & Subscriptions",
    terms_payment_desc: "Paid subscriptions are billed according to the chosen plan. You can cancel at any time. Refunds are handled on a case-by-case basis.",
    terms_termination_title: "Termination",
    terms_termination_desc: "We may suspend or terminate your account for violations of these terms. You may delete your account at any time.",
    terms_liability_title: "Limitation of Liability",
    terms_liability_desc: "VerbNotes is provided \"as is\" without warranties. We are not liable for any indirect, incidental, or consequential damages.",
    terms_changes_title: "Changes to Terms",
    terms_changes_desc: "We may update these terms from time to time. We will notify you of significant changes via email or in-app notification.",

    // Bug Report
    bug_report_title: "Report a Bug",
    bug_report_btn_title: "Report a Bug",
    bug_report_label_title: "Title",
    bug_report_title_placeholder: "Brief summary of the issue",
    bug_report_severity: "Severity",
    bug_report_description: "Description",
    bug_report_desc_placeholder: "What happened? What did you expect?",
    bug_report_steps: "Steps to Reproduce (optional)",
    bug_report_steps_placeholder: "1. Go to...\n2. Click on...\n3. See error",
    bug_report_submit: "Submit Report",
    bug_report_submitted: "Report Submitted",
    bug_report_thanks: "Thank you! We'll look into it.",
    bug_report_screenshot: "Screenshot (optional)",
    bug_report_screenshot_upload: "Upload screenshot",
    bug_report_screenshot_take: "Capture screenshot",
    bug_severity_low: "Low",
    bug_severity_medium: "Medium",
    bug_severity_high: "High",
    bug_severity_critical: "Critical",

    // Common
    common_loading: "Loading...",
    common_save: "Save",
    common_cancel: "Cancel",
    common_delete: "Delete",
    common_edit: "Edit",
    common_close: "Close",
    common_search: "Search",
    common_back: "Back",
    common_next: "Next",
    common_prev: "Previous",
    common_submit: "Submit",
    common_yes: "Yes",
    common_no: "No",
  },
  de: {
    // Navigation
    nav_login: "Anmelden",
    nav_get_started: "Loslegen",
    nav_dashboard: "Dashboard",
    nav_journal: "Tagebuch",
    nav_chat: "Chat",
    nav_insights: "Erkenntnisse",
    nav_analytics: "Analysen",
    nav_notes: "Alle Notizen",
    nav_signout: "Abmelden",
    nav_signed_as: "Angemeldet als",
    nav_mood: "Stimmung",
    nav_admin: "Admin-Panel",
    nav_back_to_app: "Zurück zur App",

    // Landing Page
    hero_title_1: "Dein Geist,",
    hero_title_2: "Verstanden",
    hero_subtitle: "Intelligentes digitales Tagebuch für mentales Wohlbefinden. Verfolge deine Stimmung, erkenne emotionale Muster und erhalte personalisierte Empfehlungen.",
    hero_cta: "Starte deine Reise",
    hero_learn_more: "Mehr erfahren",
    features_title: "Hauptfunktionen",
    features_subtitle: "Alles was du für besseres mentales Wohlbefinden brauchst",
    feature_input: "Flexible Eingabe",
    feature_input_desc: "Text, Sprache, Video oder Anregungen zur Reflexion",
    feature_coach: "Intelligenter Coach",
    feature_coach_desc: "Personalisierte Empfehlungen basierend auf deiner Geschichte",
    feature_analytics: "Visuelle Analysen",
    feature_analytics_desc: "Stimmungstrends, emotionale Muster, wöchentliche Einblicke",
    feature_privacy: "Vollständige Privatsphäre",
    feature_privacy_desc: "Ende-zu-Ende verschlüsselte Einträge",
    feature_insights: "Echtzeit-Erkenntnisse",
    feature_insights_desc: "Erkenne Auslöser und Stressmuster sobald sie auftreten",
    feature_availability: "24/7 Verfügbarkeit",
    feature_availability_desc: "Überall und jederzeit verfügbar",
    benefits_title: "Bewiesene Vorteile",
    benefits_subtitle: "Forschungsbasierte Ergebnisse für dein Wohlbefinden",
    benefit_1: "Reduzierung von Angstzuständen nach 8 Wochen (NCBI-Studie)",
    benefit_2: "Verbesserung depressiver Symptome nach 12 Wochen",
    benefit_3: "Bindungsrate nach 3 Monaten",
    benefit_4: "Zeit zwischen Eintrag und Erkenntnis",
    cta_title: "Bereit für die",
    cta_title_2: "Beta",
    cta_subtitle: "Tritt unserem Beta-Programm bei und gehöre zu den Ersten, die VerbNotes erleben.",
    cta_placeholder: "E-Mail eingeben",
    cta_button: "Beta beitreten",
    cta_signing: "Anmeldung...",
    footer_privacy: "Datenschutz",
    footer_terms: "AGB",
    footer_contact: "Kontakt",

    // Auth Pages
    login_title: "Willkommen zurück",
    login_subtitle: "Melde dich an, um deine Reise fortzusetzen",
    login_email: "E-Mail",
    login_password: "Passwort",
    login_button: "Anmelden",
    login_signing: "Anmeldung...",
    login_no_account: "Noch kein Konto?",
    login_create: "Erstelle eins",
    login_2fa_code: "2FA-Code",
    login_2fa_prompt: "Gib deinen Authentifizierungscode ein",
    login_social: "Oder weiter mit",
    register_title: "Konto erstellen",
    register_subtitle: "Starte heute deine Wellness-Reise",
    register_name: "Vollständiger Name",
    register_button: "Konto erstellen",
    register_creating: "Konto wird erstellt...",
    register_has_account: "Bereits ein Konto?",
    register_signin: "Anmelden",
    password_length: "Mindestens 8 Zeichen",
    password_number: "Enthält eine Zahl",

    // Dashboard
    dashboard_greeting_morning: "Guten Morgen",
    dashboard_greeting_afternoon: "Guten Tag",
    dashboard_greeting_evening: "Guten Abend",
    dashboard_overview: "Hier ist dein Wellness-Überblick",
    dashboard_new_entry: "Neuer Tagebucheintrag",
    dashboard_new_entry_desc: "Schreibe oder nimm deine Gedanken auf",
    dashboard_chat: "Chat mit Wellness-Coach",
    dashboard_chat_desc: "Erhalte personalisierte Unterstützung",
    dashboard_avg_mood: "Durchschn. Stimmung",
    dashboard_total_notes: "Notizen gesamt",
    dashboard_streak: "Serie",
    dashboard_progress: "Fortschritt",
    dashboard_days: "Tage",
    dashboard_recent: "Letzte Notizen",
    dashboard_view_all: "Alle anzeigen",
    dashboard_no_notes: "Noch keine Notizen. Beginne mit dem Tagebuch!",
    dashboard_insights: "Intelligente Erkenntnisse",
    dashboard_no_insights: "Füge mehr Notizen hinzu für Erkenntnisse!",

    // Mood Trend Widget
    mood_trend_title: "7-Tage Stimmungsverlauf",
    mood_trend_empty: "Keine Stimmungsdaten diese Woche. Beginne mit täglichen Check-ins!",

    // Journal
    journal_title: "Tagebuch",
    journal_subtitle: "Drücke deine Gedanken durch Text, Sprache oder Video aus",
    journal_feeling: "Wie fühlst du dich?",
    journal_mood_verylow: "Sehr niedrig",
    journal_mood_low: "Niedrig",
    journal_mood_neutral: "Neutral",
    journal_mood_good: "Gut",
    journal_mood_great: "Großartig",
    journal_tab_text: "Text",
    journal_tab_voice: "Sprache",
    journal_tab_video: "Video",
    journal_placeholder: "Was beschäftigt dich? Schreibe frei ohne Bewertung...",
    journal_characters: "Zeichen",
    journal_save: "Eintrag speichern",
    journal_record: "Tippen um Aufnahme zu starten",
    journal_recording: "Aufnahme... Tippen zum Stoppen",
    journal_ready: "Aufnahme bereit! Absenden oder erneut aufnehmen",
    journal_transcribe: "Transkribieren & Speichern",
    journal_processing: "Verarbeitung...",
    journal_saved: "Gerade gespeichert",
    journal_video_record: "Video aufnehmen",
    journal_video_upload: "Video hochladen",
    journal_video_recording: "Video wird aufgenommen... Tippen zum Stoppen",
    journal_video_ready: "Video bereit! Absenden oder erneut aufnehmen",
    journal_video_processing: "Video wird verarbeitet...",
    journal_video_or: "oder",

    // Chat
    chat_title: "Wellness-Coach",
    chat_subtitle: "Dein unterstützender Wellness-Begleiter",
    chat_welcome: "Hallo! Ich bin dein VerbNotes Wellness-Coach. Ich bin hier, um zuzuhören und dir zu helfen, über deine Gedanken und Gefühle nachzudenken. Wie geht es dir heute?",
    chat_cleared: "Chat gelöscht! Ich bin bereit für einen Neuanfang. Was beschäftigt dich?",
    chat_placeholder: "Nachricht eingeben...",
    chat_save_insight: "Erkenntnis im Tagebuch speichern",
    chat_history: "Chat-Verlauf",
    chat_history_subtitle: "Durchsuche deine vergangenen Gespräche",
    chat_search_placeholder: "Gespräche durchsuchen...",
    chat_no_history: "Noch keine Gespräche. Beginne einen Chat mit deinem Wellness-Coach!",
    chat_new_chat: "Neuer Chat",
    chat_sessions: "Sitzungen",
    chat_view_session: "Ansehen",
    chat_delete_session: "Löschen",

    // Insights
    insights_title: "Intelligente Erkenntnisse",
    insights_subtitle: "Personalisierte Muster und Empfehlungen basierend auf deinen Einträgen",
    insights_empty_title: "Noch keine Erkenntnisse",
    insights_empty_desc: "Führe weiter Tagebuch, um personalisierte Erkenntnisse über deine emotionalen Muster zu erhalten.",
    insights_emotional_patterns: "Emotionale Muster",
    insights_trending_up: "Aufwärtstrend",
    insights_trending_down: "Abwärtstrend",
    insights_stable: "Stabil",
    insights_positive: "positiv",
    insights_negative: "negativ",
    insights_neutral: "neutral",
    insights_mentions: "Erwähnungen",
    insights_positive_entries: "positive Einträge",

    // Analytics
    analytics_title: "Analysen",
    analytics_subtitle: "Verfolge deine Wellness-Reise mit datenbasierten Erkenntnissen",
    analytics_avg_mood: "Durchschn. Stimmung",
    analytics_total: "Notizen gesamt",
    analytics_streak: "Serie",
    analytics_progress: "Fortschritt",
    analytics_out_of: "von 10",
    analytics_entries: "Einträge",
    analytics_days: "Tage",
    analytics_vs_week: "vs letzte Woche",
    analytics_mood_trend: "Stimmungstrend",
    analytics_sentiment: "Gefühlsverteilung",
    analytics_topics: "Top-Themen",
    analytics_no_mood: "Noch keine Stimmungsdaten",
    analytics_no_sentiment: "Noch keine Gefühlsdaten",

    // Notes
    notes_title: "Alle Notizen",
    notes_entries: "Einträge",
    notes_search: "Notizen durchsuchen...",
    notes_all_types: "Alle Typen",
    notes_text: "Text",
    notes_voice: "Sprache",
    notes_video: "Video",
    notes_voice_note: "Sprachnotiz",
    notes_text_entry: "Texteintrag",
    notes_video_note: "Videonotiz",
    notes_mood: "Stimmung",
    notes_summary: "Zusammenfassung",
    notes_empty_title: "Keine Notizen gefunden",
    notes_empty_desc: "Beginne mit dem Tagebuch, um deine Notizen hier zu sehen",
    notes_empty_search: "Versuche einen anderen Suchbegriff",
    notes_delete_title: "Notiz löschen",
    notes_delete_desc: "Bist du sicher, dass du diese Notiz löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
    notes_cancel: "Abbrechen",
    notes_delete: "Löschen",

    // Mood Tracker
    mood_checkin_title: "Wie geht es dir?",
    mood_checkin_subtitle: "Nimm dir einen Moment, um bei dir einzuchecken",
    mood_awful: "Schrecklich",
    mood_down: "Niedergeschlagen",
    mood_okay: "Okay",
    mood_good: "Gut",
    mood_great: "Großartig",
    mood_note_placeholder: "Was beschäftigt dich? (optional)",
    mood_submit: "Stimmung erfassen & analysieren",
    mood_analyzing: "Analyse läuft...",
    mood_logged: "Stimmung erfasst",
    mood_ai_insight: "KI-Einblick",
    mood_suggestions: "Vorschläge",
    mood_continue: "Weiter zum Dashboard",
    mood_tracker_title: "Stimmungs-Tracker",
    mood_tracker_subtitle: "Deine emotionale Wellness-Reise",
    mood_avg: "Durchschn. Stimmung",
    mood_total_checkins: "Check-ins gesamt",
    mood_streak: "Serie",
    mood_top_mood: "Top-Stimmung",
    mood_distribution: "Stimmungsverteilung",
    mood_recent: "Letzte Check-ins",
    mood_no_checkins: "Noch keine Stimmungs-Check-ins. Dein erster Check-in erscheint hier.",
    mood_prev: "Zurück",
    mood_next: "Weiter",

    // Weekly Report
    mood_weekly_title: "Wöchentlicher Stimmungsbericht",
    mood_weekly_desc: "Erhalte jeden Montag eine KI-generierte Zusammenfassung deiner wöchentlichen Stimmungsmuster per E-Mail.",
    mood_weekly_enabled: "Wöchentlicher Bericht aktiviert",
    mood_weekly_disabled: "Wöchentlicher Bericht deaktiviert",
    mood_weekly_toggle_on: "Wochenbericht aktivieren",
    mood_weekly_toggle_off: "Wochenbericht deaktivieren",
    mood_weekly_preview: "Bericht ansehen",
    mood_weekly_no_data: "Noch nicht genügend Stimmungsdaten. Checke täglich ein!",

    // Settings
    settings_title: "Einstellungen",
    settings_preferences: "Einstellungen",
    settings_2fa_title: "Zwei-Faktor-Authentifizierung",
    settings_2fa_desc: "Füge deinem Konto eine zusätzliche Sicherheitsebene mit Google Authenticator hinzu.",
    settings_2fa_enabled: "2FA ist aktiviert",
    settings_2fa_disabled: "2FA ist nicht aktiviert",
    settings_2fa_setup: "2FA einrichten",
    settings_2fa_disable: "2FA deaktivieren",
    settings_2fa_scan: "Scanne diesen QR-Code mit Google Authenticator",
    settings_2fa_enter_code: "Gib den 6-stelligen Code aus deiner App ein",
    settings_2fa_verify: "Überprüfen & Aktivieren",
    settings_subscription: "Abonnement",
    settings_manage_sub: "Abonnement verwalten",
    settings_connected: "Verbundene Dienste",
    settings_connect: "Verbinden",
    settings_disconnect: "Trennen",
    settings_connected_desc: "Verbinde externe Dienste, um dein KI-Erlebnis zu verbessern",

    // Pricing Page
    pricing_title: "Wähle deinen Plan",
    pricing_subtitle: "Starte kostenlos, upgrade wenn du bereit bist",
    pricing_monthly: "Monatlich",
    pricing_yearly: "Jährlich",
    pricing_save: "Sparen",
    pricing_current: "Aktueller Plan",
    pricing_upgrade: "Upgrade",
    pricing_downgrade: "Downgrade",
    pricing_get_started: "Loslegen",
    pricing_per_month: "/Monat",
    pricing_per_year: "/Jahr",
    pricing_one_time: "Einmalzahlung",
    pricing_popular: "Am beliebtesten",
    pricing_free_desc: "Perfekt zum Einstieg",
    pricing_basic_desc: "Für regelmäßige Tagebuchschreiber",
    pricing_premium_desc: "Für ernsthafte Selbstverbesserung",
    pricing_lifetime_desc: "Bester Langzeitwert",

    // Contact Page
    contact_title: "Kontaktiere uns",
    contact_subtitle: "Wir freuen uns von dir zu hören. Sende uns eine Nachricht!",
    contact_name: "Name",
    contact_name_placeholder: "Dein Name",
    contact_email: "E-Mail",
    contact_email_placeholder: "deine@email.com",
    contact_subject: "Betreff",
    contact_subject_placeholder: "Worum geht es?",
    contact_message: "Nachricht",
    contact_message_placeholder: "Erzähl uns, was dich beschäftigt...",
    contact_send: "Nachricht senden",
    contact_sending: "Wird gesendet...",
    contact_success: "Nachricht erfolgreich gesendet!",
    contact_error: "Bitte fülle alle Pflichtfelder aus.",
    contact_company: "Liber Nostra d.o.o.",
    contact_address: "Zagreb, Kroatien",
    contact_back: "Zurück zur Startseite",

    // Privacy Page
    privacy_title: "Datenschutzrichtlinie",
    privacy_last_updated: "Zuletzt aktualisiert",
    privacy_intro: "VerbNotes (\"wir\", \"uns\" oder \"unser\") verpflichtet sich zum Schutz Ihrer Privatsphäre. Diese Richtlinie erklärt, wie wir Ihre Daten erheben, verwenden und schützen.",
    privacy_collect_title: "Erhobene Daten",
    privacy_collect_desc: "Wir erheben Daten, die Sie direkt angeben: Kontodaten (Name, E-Mail), Tagebucheinträge, Stimmungsdaten, Sprachaufnahmen und Videoaufnahmen. Außerdem erheben wir automatisch Nutzungs- und Geräteinformationen.",
    privacy_use_title: "Verwendung Ihrer Daten",
    privacy_use_desc: "Ihre Daten werden verwendet, um unsere Dienste bereitzustellen und zu verbessern, KI-gestützte Erkenntnisse zu generieren und Ihr Erlebnis zu personalisieren. Wir verkaufen Ihre persönlichen Daten niemals an Dritte.",
    privacy_security_title: "Datensicherheit",
    privacy_security_desc: "Wir setzen branchenübergreifende Sicherheitsmaßnahmen zum Schutz Ihrer Daten ein, einschließlich Verschlüsselung bei Übertragung und Speicherung.",
    privacy_rights_title: "Ihre Rechte",
    privacy_rights_desc: "Sie haben jederzeit das Recht auf Zugang, Berichtigung oder Löschung Ihrer persönlichen Daten. Kontaktieren Sie uns unter support@verbnotes.com.",
    privacy_cookies_title: "Cookies",
    privacy_cookies_desc: "Wir verwenden essenzielle Cookies für Authentifizierung und Einstellungen. Analyse-Cookies werden nur mit Ihrer Zustimmung verwendet.",
    privacy_contact_title: "Kontakt",
    privacy_contact_desc: "Für datenschutzbezogene Anfragen kontaktieren Sie uns bitte unter support@verbnotes.com.",

    // Terms Page
    terms_title: "Nutzungsbedingungen",
    terms_last_updated: "Zuletzt aktualisiert",
    terms_intro: "Durch die Nutzung von VerbNotes stimmen Sie diesen Nutzungsbedingungen zu. Bitte lesen Sie diese sorgfältig durch.",
    terms_use_title: "Nutzung des Dienstes",
    terms_use_desc: "VerbNotes bietet KI-gestützte Tagebuch- und Wellness-Tools. Sie müssen mindestens 16 Jahre alt sein. Sie sind für die Vertraulichkeit Ihres Kontos verantwortlich.",
    terms_content_title: "Ihre Inhalte",
    terms_content_desc: "Sie behalten das Eigentum an allen erstellten Inhalten. Durch die Nutzung gewähren Sie uns eine begrenzte Lizenz zur Verarbeitung für KI-Analyse und Dienstbereitstellung.",
    terms_ai_title: "KI-Haftungsausschluss",
    terms_ai_desc: "Unsere KI-Funktionen bieten allgemeine Wellness-Vorschläge und sind kein Ersatz für professionelle medizinische oder psychologische Beratung.",
    terms_payment_title: "Zahlungen & Abonnements",
    terms_payment_desc: "Bezahlte Abonnements werden nach dem gewählten Plan abgerechnet. Sie können jederzeit kündigen. Rückerstattungen werden im Einzelfall behandelt.",
    terms_termination_title: "Kündigung",
    terms_termination_desc: "Wir können Ihr Konto bei Verstößen gegen diese Bedingungen sperren oder kündigen. Sie können Ihr Konto jederzeit löschen.",
    terms_liability_title: "Haftungsbeschränkung",
    terms_liability_desc: "VerbNotes wird \"wie besehen\" ohne Garantien bereitgestellt. Wir haften nicht für indirekte, zufällige oder Folgeschäden.",
    terms_changes_title: "Änderungen der Bedingungen",
    terms_changes_desc: "Wir können diese Bedingungen von Zeit zu Zeit aktualisieren. Über wesentliche Änderungen informieren wir Sie per E-Mail oder In-App-Benachrichtigung.",

    // Bug Report
    bug_report_title: "Fehler melden",
    bug_report_btn_title: "Fehler melden",
    bug_report_label_title: "Titel",
    bug_report_title_placeholder: "Kurze Zusammenfassung des Problems",
    bug_report_severity: "Schweregrad",
    bug_report_description: "Beschreibung",
    bug_report_desc_placeholder: "Was ist passiert? Was hast du erwartet?",
    bug_report_steps: "Schritte zur Reproduktion (optional)",
    bug_report_steps_placeholder: "1. Gehe zu...\n2. Klicke auf...\n3. Fehler sichtbar",
    bug_report_submit: "Bericht senden",
    bug_report_submitted: "Bericht gesendet",
    bug_report_thanks: "Danke! Wir kümmern uns darum.",
    bug_report_screenshot: "Screenshot (optional)",
    bug_report_screenshot_upload: "Screenshot hochladen",
    bug_report_screenshot_take: "Screenshot aufnehmen",
    bug_severity_low: "Niedrig",
    bug_severity_medium: "Mittel",
    bug_severity_high: "Hoch",
    bug_severity_critical: "Kritisch",

    // Common
    common_loading: "Laden...",
    common_save: "Speichern",
    common_cancel: "Abbrechen",
    common_delete: "Löschen",
    common_edit: "Bearbeiten",
    common_close: "Schließen",
    common_search: "Suche",
    common_back: "Zurück",
    common_next: "Weiter",
    common_prev: "Zurück",
    common_submit: "Absenden",
    common_yes: "Ja",
    common_no: "Nein",
  },
  hr: {
    // Navigation
    nav_login: "Prijava",
    nav_get_started: "Započni",
    nav_dashboard: "Nadzorna ploča",
    nav_journal: "Dnevnik",
    nav_chat: "Razgovor",
    nav_insights: "Uvidi",
    nav_analytics: "Analitika",
    nav_notes: "Sve bilješke",
    nav_signout: "Odjava",
    nav_signed_as: "Prijavljeni kao",
    nav_mood: "Raspoloženje",
    nav_admin: "Admin panel",
    nav_back_to_app: "Natrag u aplikaciju",

    // Landing Page
    hero_title_1: "Tvoj um je",
    hero_title_2: "shvaćen",
    hero_subtitle: "Pametno digitalno vođenje dnevnika za mentalno zdravlje. Prati svoje raspoloženje, prepoznaj emocionalne obrasce i dobij personalizirane preporuke.",
    hero_cta: "Započni svoje putovanje",
    hero_learn_more: "Saznaj više",
    features_title: "Ključne značajke",
    features_subtitle: "Sve što trebaš za bolje mentalno zdravlje",
    feature_input: "Fleksibilan unos",
    feature_input_desc: "Tekst, glas, video ili poticaji za refleksiju",
    feature_coach: "Pametni coach",
    feature_coach_desc: "Personalizirane preporuke temeljene na tvojoj povijesti",
    feature_analytics: "Vizualna analitika",
    feature_analytics_desc: "Trendovi raspoloženja, emocionalni obrasci, tjedni uvidi",
    feature_privacy: "Potpuna privatnost",
    feature_privacy_desc: "Potpuno šifrirani unosi",
    feature_insights: "Uvidi u stvarnom vremenu",
    feature_insights_desc: "Prepoznaj okidače i obrasce stresa čim se pojave",
    feature_availability: "Dostupnost 24/7",
    feature_availability_desc: "Dostupno bilo gdje, bilo kada",
    benefits_title: "Dokazane prednosti",
    benefits_subtitle: "Rezultati temeljeni na istraživanjima za tvoju dobrobit",
    benefit_1: "Smanjenje anksioznosti nakon 8 tjedana (NCBI studija)",
    benefit_2: "Poboljšanje depresivnih simptoma nakon 12 tjedana",
    benefit_3: "Stopa zadržavanja nakon 3 mjeseca",
    benefit_4: "Vrijeme između unosa i uvida",
    cta_title: "Spreman si za",
    cta_title_2: "beta verziju",
    cta_subtitle: "Pridruži se našem beta programu i budi među prvima koji će iskusiti VerbNotes.",
    cta_placeholder: "Unesi svoj email",
    cta_button: "Pridruži se",
    cta_signing: "Prijava u tijeku...",
    footer_privacy: "Privatnost",
    footer_terms: "Uvjeti",
    footer_contact: "Kontakt",

    // Auth Pages
    login_title: "Dobro došao natrag",
    login_subtitle: "Prijavi se za nastavak putovanja",
    login_email: "Email",
    login_password: "Lozinka",
    login_button: "Prijavi se",
    login_signing: "Prijava u tijeku...",
    login_no_account: "Nemaš račun?",
    login_create: "Kreiraj ga",
    login_2fa_code: "2FA kôd",
    login_2fa_prompt: "Unesi kôd iz autentifikatora",
    login_social: "Ili nastavi s",
    register_title: "Kreiraj račun",
    register_subtitle: "Započni svoje putovanje prema dobrobiti danas",
    register_name: "Puno ime",
    register_button: "Kreiraj račun",
    register_creating: "Kreiranje računa...",
    register_has_account: "Već imaš račun?",
    register_signin: "Prijavi se",
    password_length: "Najmanje 8 znakova",
    password_number: "Sadrži broj",

    // Dashboard
    dashboard_greeting_morning: "Dobro jutro",
    dashboard_greeting_afternoon: "Dobar dan",
    dashboard_greeting_evening: "Dobra večer",
    dashboard_overview: "Evo tvog pregleda dobrobiti",
    dashboard_new_entry: "Novi unos u dnevnik",
    dashboard_new_entry_desc: "Napiši ili snimi svoje misli",
    dashboard_chat: "Razgovaraj s coachom",
    dashboard_chat_desc: "Dobij personaliziranu podršku",
    dashboard_avg_mood: "Prosječno raspoloženje",
    dashboard_total_notes: "Ukupno bilješki",
    dashboard_streak: "Niz dana",
    dashboard_progress: "Napredak",
    dashboard_days: "dana",
    dashboard_recent: "Nedavne bilješke",
    dashboard_view_all: "Prikaži sve",
    dashboard_no_notes: "Još nema bilješki. Započni s pisanjem dnevnika!",
    dashboard_insights: "Pametni uvidi",
    dashboard_no_insights: "Dodaj više bilješki da dobiješ uvide!",

    // Mood Trend Widget
    mood_trend_title: "7-dnevni trend raspoloženja",
    mood_trend_empty: "Nema podataka o raspoloženju ovaj tjedan. Počni s dnevnim provjerama!",

    // Journal
    journal_title: "Dnevnik",
    journal_subtitle: "Izrazi svoje misli kroz tekst, glas ili video",
    journal_feeling: "Kako se osjećaš?",
    journal_mood_verylow: "Vrlo loše",
    journal_mood_low: "Loše",
    journal_mood_neutral: "Neutralno",
    journal_mood_good: "Dobro",
    journal_mood_great: "Odlično",
    journal_tab_text: "Tekst",
    journal_tab_voice: "Glas",
    journal_tab_video: "Video",
    journal_placeholder: "Što ti je na umu? Piši slobodno bez prosudbe...",
    journal_characters: "znakova",
    journal_save: "Spremi unos",
    journal_record: "Dodirni za početak snimanja",
    journal_recording: "Snimanje... Dodirni za zaustavljanje",
    journal_ready: "Snimka je spremna! Pošalji ili snimi ponovo",
    journal_transcribe: "Transkribiraj i spremi",
    journal_processing: "Obrada u tijeku...",
    journal_saved: "Upravo spremljeno",
    journal_video_record: "Snimi video",
    journal_video_upload: "Učitaj video",
    journal_video_recording: "Snimanje videa... Dodirni za zaustavljanje",
    journal_video_ready: "Video je spreman! Pošalji ili snimi ponovo",
    journal_video_processing: "Obrada videa...",
    journal_video_or: "ili",

    // Chat
    chat_title: "Coach za dobrobit",
    chat_subtitle: "Tvoj podržavajući pratitelj",
    chat_welcome: "Bok! Ja sam tvoj VerbNotes coach. Ovdje sam da slušam i pomognem ti razmisliti o svojim mislima i osjećajima. Kako si danas?",
    chat_cleared: "Razgovor je izbrisan! Spreman sam za novi početak. Što ti je na umu?",
    chat_placeholder: "Upiši svoju poruku...",
    chat_save_insight: "Spremi uvid u dnevnik",
    chat_history: "Povijest razgovora",
    chat_history_subtitle: "Pregledaj i pretraži prethodne razgovore",
    chat_search_placeholder: "Pretraži razgovore...",
    chat_no_history: "Još nema razgovora. Započni razgovor s coachom!",
    chat_new_chat: "Novi razgovor",
    chat_sessions: "Sesije",
    chat_view_session: "Pregledaj",
    chat_delete_session: "Izbriši",

    // Insights
    insights_title: "Pametni uvidi",
    insights_subtitle: "Personalizirani obrasci i preporuke temeljene na tvojim unosima",
    insights_empty_title: "Još nema uvida",
    insights_empty_desc: "Nastavi voditi dnevnik da otključaš personalizirane uvide o svojim emocionalnim obrascima.",
    insights_emotional_patterns: "Emocionalni obrasci",
    insights_trending_up: "Uzlazni trend",
    insights_trending_down: "Silazni trend",
    insights_stable: "Stabilno",
    insights_positive: "pozitivno",
    insights_negative: "negativno",
    insights_neutral: "neutralno",
    insights_mentions: "spominjanja",
    insights_positive_entries: "pozitivnih unosa",

    // Analytics
    analytics_title: "Analitika",
    analytics_subtitle: "Prati svoj put prema dobrobiti s uvidima temeljenima na podacima",
    analytics_avg_mood: "Prosječno raspoloženje",
    analytics_total: "Ukupno bilješki",
    analytics_streak: "Niz dana",
    analytics_progress: "Napredak",
    analytics_out_of: "od 10",
    analytics_entries: "unosa",
    analytics_days: "dana",
    analytics_vs_week: "u odnosu na prošli tjedan",
    analytics_mood_trend: "Trend raspoloženja",
    analytics_sentiment: "Raspodjela osjećaja",
    analytics_topics: "Glavne teme",
    analytics_no_mood: "Još nema podataka o raspoloženju",
    analytics_no_sentiment: "Još nema podataka o osjećajima",

    // Notes
    notes_title: "Sve bilješke",
    notes_entries: "unosa",
    notes_search: "Pretraži bilješke...",
    notes_all_types: "Svi tipovi",
    notes_text: "Tekst",
    notes_voice: "Glas",
    notes_video: "Video",
    notes_voice_note: "Glasovna bilješka",
    notes_text_entry: "Tekstualni unos",
    notes_video_note: "Video bilješka",
    notes_mood: "Raspoloženje",
    notes_summary: "Sažetak",
    notes_empty_title: "Nema pronađenih bilješki",
    notes_empty_desc: "Započni s pisanjem dnevnika da vidiš svoje bilješke ovdje",
    notes_empty_search: "Pokušaj s drugim pojmom za pretragu",
    notes_delete_title: "Brisanje bilješke",
    notes_delete_desc: "Jesi li siguran da želiš izbrisati ovu bilješku? Ova se radnja ne može poništiti.",
    notes_cancel: "Odustani",
    notes_delete: "Izbriši",

    // Mood Tracker
    mood_checkin_title: "Kako se osjećaš?",
    mood_checkin_subtitle: "Odvojite trenutak za provjeru",
    mood_awful: "Užasno",
    mood_down: "Loše",
    mood_okay: "U redu",
    mood_good: "Dobro",
    mood_great: "Odlično",
    mood_note_placeholder: "Što ti je na umu? (neobavezno)",
    mood_submit: "Zabilježi i analiziraj",
    mood_analyzing: "Analiziranje...",
    mood_logged: "Raspoloženje zabilježeno",
    mood_ai_insight: "AI uvid",
    mood_suggestions: "Prijedlozi",
    mood_continue: "Nastavi na ploču",
    mood_tracker_title: "Praćenje raspoloženja",
    mood_tracker_subtitle: "Tvoje putovanje emocionalnog zdravlja",
    mood_avg: "Prosječno",
    mood_total_checkins: "Ukupno provjera",
    mood_streak: "Niz dana",
    mood_top_mood: "Najčešće",
    mood_distribution: "Raspodjela raspoloženja",
    mood_recent: "Nedavne provjere",
    mood_no_checkins: "Još nema provjera raspoloženja. Prva provjera pojavit će se ovdje.",
    mood_prev: "Prethodno",
    mood_next: "Sljedeće",

    // Weekly Report
    mood_weekly_title: "Tjedni izvještaj o raspoloženju",
    mood_weekly_desc: "Primajte svaki ponedjeljak AI-generirani sažetak tjednih obrazaca raspoloženja putem e-pošte.",
    mood_weekly_enabled: "Tjedni izvještaj uključen",
    mood_weekly_disabled: "Tjedni izvještaj isključen",
    mood_weekly_toggle_on: "Uključi tjedni izvještaj",
    mood_weekly_toggle_off: "Isključi tjedni izvještaj",
    mood_weekly_preview: "Pregledaj izvještaj",
    mood_weekly_no_data: "Još nema dovoljno podataka. Provjeravajte se svaki dan!",

    // Settings
    settings_title: "Postavke",
    settings_preferences: "Postavke",
    settings_2fa_title: "Dvofaktorska autentifikacija",
    settings_2fa_desc: "Dodaj dodatni sloj sigurnosti svom računu pomoću Google Authenticatora.",
    settings_2fa_enabled: "2FA je aktiviran",
    settings_2fa_disabled: "2FA nije aktiviran",
    settings_2fa_setup: "Postavi 2FA",
    settings_2fa_disable: "Onemogući 2FA",
    settings_2fa_scan: "Skeniraj ovaj QR kôd pomoću Google Authenticatora",
    settings_2fa_enter_code: "Unesi 6-znamenkasti kôd iz aplikacije",
    settings_2fa_verify: "Provjeri i aktiviraj",
    settings_subscription: "Pretplata",
    settings_manage_sub: "Upravljaj pretplatom",
    settings_connected: "Povezane usluge",
    settings_connect: "Poveži",
    settings_disconnect: "Prekini vezu",
    settings_connected_desc: "Poveži vanjske usluge za poboljšanje AI iskustva",

    // Pricing Page
    pricing_title: "Odaberi svoj plan",
    pricing_subtitle: "Započni besplatno, nadogradi kad si spreman",
    pricing_monthly: "Mjesečno",
    pricing_yearly: "Godišnje",
    pricing_save: "Ušteda",
    pricing_current: "Trenutni plan",
    pricing_upgrade: "Nadogradi",
    pricing_downgrade: "Sniži",
    pricing_get_started: "Započni",
    pricing_per_month: "/mjesečno",
    pricing_per_year: "/godišnje",
    pricing_one_time: "Jednokratna uplata",
    pricing_popular: "Najpopularniji",
    pricing_free_desc: "Savršeno za početak",
    pricing_basic_desc: "Za redovite pisače dnevnika",
    pricing_premium_desc: "Za ozbiljno samopoboljšanje",
    pricing_lifetime_desc: "Najbolja dugoročna vrijednost",

    // Contact Page
    contact_title: "Kontaktirajte nas",
    contact_subtitle: "Rado bismo vas čuli. Pošaljite nam poruku!",
    contact_name: "Ime",
    contact_name_placeholder: "Vaše ime",
    contact_email: "Email",
    contact_email_placeholder: "vaš@email.com",
    contact_subject: "Predmet",
    contact_subject_placeholder: "O čemu se radi?",
    contact_message: "Poruka",
    contact_message_placeholder: "Recite nam što vas zanima...",
    contact_send: "Pošalji poruku",
    contact_sending: "Slanje...",
    contact_success: "Poruka uspješno poslana!",
    contact_error: "Molimo ispunite sva obavezna polja.",
    contact_company: "Liber Nostra d.o.o.",
    contact_address: "Zagreb, Hrvatska",
    contact_back: "Natrag na početnu",

    // Privacy Page
    privacy_title: "Pravila privatnosti",
    privacy_last_updated: "Posljednje ažuriranje",
    privacy_intro: "VerbNotes (\"mi\", \"nas\" ili \"naše\") posvećen je zaštiti vaše privatnosti. Ova pravila objašnjavaju kako prikupljamo, koristimo i štitimo vaše podatke.",
    privacy_collect_title: "Podatci koje prikupljamo",
    privacy_collect_desc: "Prikupljamo podatke koje izravno pružate: podatke o računu (ime, email), dnevničke zapise, podatke o raspoloženju, glasovne i video snimke. Također automatski prikupljamo podatke o korištenju i uređaju.",
    privacy_use_title: "Kako koristimo vaše podatke",
    privacy_use_desc: "Vaši se podatci koriste za pružanje i poboljšanje naših usluga, generiranje AI uvida i personalizaciju iskustva. Nikada ne prodajemo vaše osobne podatke trećim stranama.",
    privacy_security_title: "Sigurnost podataka",
    privacy_security_desc: "Primjenjujemo industrijske standarde sigurnosti za zaštitu vaših podataka, uključujući enkripciju tijekom prijenosa i pohrane.",
    privacy_rights_title: "Vaša prava",
    privacy_rights_desc: "Imate pravo pristupiti, ispraviti ili izbrisati svoje osobne podatke u bilo kojem trenutku. Kontaktirajte nas na support@verbnotes.com.",
    privacy_cookies_title: "Kolačići",
    privacy_cookies_desc: "Koristimo osnovne kolačiće za autentifikaciju i postavke. Analitički kolačići koriste se samo uz vaš pristanak.",
    privacy_contact_title: "Kontakt",
    privacy_contact_desc: "Za upite vezane uz privatnost, kontaktirajte nas na support@verbnotes.com.",

    // Terms Page
    terms_title: "Uvjeti korištenja",
    terms_last_updated: "Posljednje ažuriranje",
    terms_intro: "Korištenjem VerbNotesa pristajete na ove Uvjete korištenja. Molimo pročitajte ih pažljivo.",
    terms_use_title: "Korištenje usluge",
    terms_use_desc: "VerbNotes pruža AI alate za vođenje dnevnika i wellness. Morate imati najmanje 16 godina. Odgovorni ste za povjerljivost svog računa.",
    terms_content_title: "Vaš sadržaj",
    terms_content_desc: "Zadržavate vlasništvo nad svim sadržajem koji kreirate. Korištenjem usluge dajete nam ograničenu licencu za obradu sadržaja za AI analizu.",
    terms_ai_title: "AI odricanje odgovornosti",
    terms_ai_desc: "Naše AI funkcije pružaju opće wellness prijedloge i nisu zamjena za profesionalni medicinski ili psihološki savjet.",
    terms_payment_title: "Plaćanja i pretplate",
    terms_payment_desc: "Plaćene pretplate naplaćuju se prema odabranom planu. Možete otkazati u bilo kojem trenutku. Povrati se rješavaju od slučaja do slučaja.",
    terms_termination_title: "Prekid",
    terms_termination_desc: "Možemo suspendirati ili ukinuti vaš račun zbog kršenja ovih uvjeta. Možete izbrisati svoj račun u bilo kojem trenutku.",
    terms_liability_title: "Ograničenje odgovornosti",
    terms_liability_desc: "VerbNotes se pruža \"kao što jest\" bez garancija. Ne odgovaramo za neizravnu, slučajnu ili posljedičnu štetu.",
    terms_changes_title: "Promjene uvjeta",
    terms_changes_desc: "Možemo ažurirati ove uvjete s vremena na vrijeme. O značajnim promjenama obavijestit ćemo vas putem e-pošte ili obavijesti u aplikaciji.",

    // Bug Report
    bug_report_title: "Prijavi grešku",
    bug_report_btn_title: "Prijavi grešku",
    bug_report_label_title: "Naslov",
    bug_report_title_placeholder: "Kratak opis problema",
    bug_report_severity: "Ozbiljnost",
    bug_report_description: "Opis",
    bug_report_desc_placeholder: "Što se dogodilo? Što ste očekivali?",
    bug_report_steps: "Koraci za reprodukciju (opcionalno)",
    bug_report_steps_placeholder: "1. Idi na...\n2. Klikni na...\n3. Vidi grešku",
    bug_report_submit: "Pošalji prijavu",
    bug_report_submitted: "Prijava poslana",
    bug_report_thanks: "Hvala! Istražit ćemo to.",
    bug_report_screenshot: "Snimka zaslona (opcionalno)",
    bug_report_screenshot_upload: "Učitaj snimku zaslona",
    bug_report_screenshot_take: "Snimi zaslon",
    bug_severity_low: "Nisko",
    bug_severity_medium: "Srednje",
    bug_severity_high: "Visoko",
    bug_severity_critical: "Kritično",

    // Common
    common_loading: "Učitavanje...",
    common_save: "Spremi",
    common_cancel: "Odustani",
    common_delete: "Izbriši",
    common_edit: "Uredi",
    common_close: "Zatvori",
    common_search: "Pretraga",
    common_back: "Natrag",
    common_next: "Sljedeće",
    common_prev: "Prethodno",
    common_submit: "Pošalji",
    common_yes: "Da",
    common_no: "Ne",
  },
  es: {
    // Navigation
    nav_login: "Iniciar sesión",
    nav_get_started: "Comenzar",
    nav_dashboard: "Panel",
    nav_journal: "Diario",
    nav_chat: "Chat",
    nav_insights: "Perspectivas",
    nav_analytics: "Análisis",
    nav_notes: "Todas las notas",
    nav_signout: "Cerrar sesión",
    nav_signed_as: "Conectado como",
    nav_mood: "Ánimo",
    nav_admin: "Panel de Admin",
    nav_back_to_app: "Volver a la App",

    // Landing Page
    hero_title_1: "Tu mente,",
    hero_title_2: "Comprendida",
    hero_subtitle: "Diario digital inteligente para el bienestar mental. Rastrea tu estado de ánimo, detecta patrones emocionales y obtén recomendaciones personalizadas.",
    hero_cta: "Comienza tu viaje",
    hero_learn_more: "Saber más",
    features_title: "Características principales",
    features_subtitle: "Todo lo que necesitas para un mejor bienestar mental",
    feature_input: "Entrada flexible",
    feature_input_desc: "Texto, voz, video o indicaciones que fomentan la reflexión",
    feature_coach: "Coach inteligente",
    feature_coach_desc: "Recomendaciones personalizadas basadas en tu historial",
    feature_analytics: "Análisis visual",
    feature_analytics_desc: "Tendencias de ánimo, patrones emocionales, perspectivas semanales",
    feature_privacy: "Privacidad completa",
    feature_privacy_desc: "Entradas cifradas de extremo a extremo",
    feature_insights: "Perspectivas en tiempo real",
    feature_insights_desc: "Detecta desencadenantes y patrones de estrés cuando surgen",
    feature_availability: "Disponibilidad 24/7",
    feature_availability_desc: "Disponible en cualquier lugar, en cualquier momento",
    benefits_title: "Beneficios comprobados",
    benefits_subtitle: "Resultados respaldados por investigación para tu bienestar",
    benefit_1: "Reducción de la ansiedad después de 8 semanas (estudio NCBI)",
    benefit_2: "Mejora de síntomas depresivos después de 12 semanas",
    benefit_3: "Tasa de retención después de 3 meses",
    benefit_4: "Tiempo entre entrada y perspectiva",
    cta_title: "Listo para la",
    cta_title_2: "Beta",
    cta_subtitle: "Únete a nuestro programa beta y sé de los primeros en experimentar VerbNotes.",
    cta_placeholder: "Ingresa tu email",
    cta_button: "Unirse a Beta",
    cta_signing: "Registrando...",
    footer_privacy: "Privacidad",
    footer_terms: "Términos",
    footer_contact: "Contacto",

    // Auth Pages
    login_title: "Bienvenido de nuevo",
    login_subtitle: "Inicia sesión para continuar tu viaje",
    login_email: "Email",
    login_password: "Contraseña",
    login_button: "Iniciar sesión",
    login_signing: "Iniciando sesión...",
    login_no_account: "¿No tienes cuenta?",
    login_create: "Crea una",
    login_2fa_code: "Código 2FA",
    login_2fa_prompt: "Ingresa tu código de autenticación",
    login_social: "O continúa con",
    register_title: "Crear cuenta",
    register_subtitle: "Comienza tu viaje de bienestar hoy",
    register_name: "Nombre completo",
    register_button: "Crear cuenta",
    register_creating: "Creando cuenta...",
    register_has_account: "¿Ya tienes cuenta?",
    register_signin: "Inicia sesión",
    password_length: "Al menos 8 caracteres",
    password_number: "Contiene un número",

    // Dashboard
    dashboard_greeting_morning: "Buenos días",
    dashboard_greeting_afternoon: "Buenas tardes",
    dashboard_greeting_evening: "Buenas noches",
    dashboard_overview: "Aquí está tu resumen de bienestar",
    dashboard_new_entry: "Nueva entrada de diario",
    dashboard_new_entry_desc: "Escribe o graba tus pensamientos",
    dashboard_chat: "Chatea con el coach de bienestar",
    dashboard_chat_desc: "Obtén apoyo personalizado",
    dashboard_avg_mood: "Ánimo prom.",
    dashboard_total_notes: "Notas totales",
    dashboard_streak: "Racha",
    dashboard_progress: "Progreso",
    dashboard_days: "días",
    dashboard_recent: "Notas recientes",
    dashboard_view_all: "Ver todo",
    dashboard_no_notes: "Sin notas aún. ¡Comienza a escribir!",
    dashboard_insights: "Perspectivas inteligentes",
    dashboard_no_insights: "¡Agrega más notas para desbloquear perspectivas!",

    // Mood Trend Widget
    mood_trend_title: "Tendencia de ánimo de 7 días",
    mood_trend_empty: "Sin datos de ánimo esta semana. ¡Empieza a registrarte diariamente!",

    // Journal
    journal_title: "Diario",
    journal_subtitle: "Expresa tus pensamientos a través de texto, voz o video",
    journal_feeling: "¿Cómo te sientes?",
    journal_mood_verylow: "Muy bajo",
    journal_mood_low: "Bajo",
    journal_mood_neutral: "Neutral",
    journal_mood_good: "Bien",
    journal_mood_great: "Excelente",
    journal_tab_text: "Texto",
    journal_tab_voice: "Voz",
    journal_tab_video: "Video",
    journal_placeholder: "¿Qué tienes en mente? Escribe libremente sin juicio...",
    journal_characters: "caracteres",
    journal_save: "Guardar entrada",
    journal_record: "Toca para empezar a grabar",
    journal_recording: "Grabando... Toca para detener",
    journal_ready: "¡Grabación lista! Envía o graba de nuevo",
    journal_transcribe: "Transcribir y guardar",
    journal_processing: "Procesando...",
    journal_saved: "Recién guardado",
    journal_video_record: "Grabar video",
    journal_video_upload: "Subir video",
    journal_video_recording: "Grabando video... Toca para detener",
    journal_video_ready: "¡Video listo! Envía o graba de nuevo",
    journal_video_processing: "Procesando video...",
    journal_video_or: "o",

    // Chat
    chat_title: "Coach de bienestar",
    chat_subtitle: "Tu compañero de bienestar de apoyo",
    chat_welcome: "¡Hola! Soy tu VerbNotes Coach de Bienestar. Estoy aquí para escucharte y ayudarte a reflexionar sobre tus pensamientos y sentimientos. ¿Cómo estás hoy?",
    chat_cleared: "¡Chat limpiado! Estoy listo para empezar de nuevo. ¿Qué tienes en mente?",
    chat_placeholder: "Escribe tu mensaje...",
    chat_save_insight: "Guardar perspectiva en el diario",
    chat_history: "Historial de chat",
    chat_history_subtitle: "Navega y busca tus conversaciones anteriores",
    chat_search_placeholder: "Buscar conversaciones...",
    chat_no_history: "Sin conversaciones aún. ¡Comienza a chatear con tu Coach!",
    chat_new_chat: "Nuevo chat",
    chat_sessions: "Sesiones",
    chat_view_session: "Ver",
    chat_delete_session: "Eliminar",

    // Insights
    insights_title: "Perspectivas inteligentes",
    insights_subtitle: "Patrones personalizados y recomendaciones basadas en tus entradas",
    insights_empty_title: "Sin perspectivas aún",
    insights_empty_desc: "Sigue escribiendo en tu diario para desbloquear perspectivas personalizadas sobre tus patrones emocionales.",
    insights_emotional_patterns: "Patrones emocionales",
    insights_trending_up: "Tendencia al alza",
    insights_trending_down: "Tendencia a la baja",
    insights_stable: "Estable",
    insights_positive: "positivo",
    insights_negative: "negativo",
    insights_neutral: "neutral",
    insights_mentions: "menciones",
    insights_positive_entries: "entradas positivas",

    // Analytics
    analytics_title: "Análisis",
    analytics_subtitle: "Rastrea tu viaje de bienestar con perspectivas basadas en datos",
    analytics_avg_mood: "Ánimo prom.",
    analytics_total: "Notas totales",
    analytics_streak: "Racha",
    analytics_progress: "Progreso",
    analytics_out_of: "de 10",
    analytics_entries: "entradas",
    analytics_days: "días",
    analytics_vs_week: "vs semana pasada",
    analytics_mood_trend: "Tendencia de ánimo",
    analytics_sentiment: "Distribución de sentimientos",
    analytics_topics: "Temas principales",
    analytics_no_mood: "Sin datos de ánimo aún",
    analytics_no_sentiment: "Sin datos de sentimientos aún",

    // Notes
    notes_title: "Todas las notas",
    notes_entries: "entradas",
    notes_search: "Buscar notas...",
    notes_all_types: "Todos los tipos",
    notes_text: "Texto",
    notes_voice: "Voz",
    notes_video: "Video",
    notes_voice_note: "Nota de voz",
    notes_text_entry: "Entrada de texto",
    notes_video_note: "Nota de video",
    notes_mood: "Ánimo",
    notes_summary: "Resumen",
    notes_empty_title: "No se encontraron notas",
    notes_empty_desc: "Comienza a escribir en tu diario para ver tus notas aquí",
    notes_empty_search: "Prueba con un término de búsqueda diferente",
    notes_delete_title: "Eliminar nota",
    notes_delete_desc: "¿Estás seguro de que quieres eliminar esta nota? Esta acción no se puede deshacer.",
    notes_cancel: "Cancelar",
    notes_delete: "Eliminar",

    // Mood Tracker
    mood_checkin_title: "¿Cómo te sientes?",
    mood_checkin_subtitle: "Tómate un momento para reflexionar",
    mood_awful: "Terrible",
    mood_down: "Bajo",
    mood_okay: "Normal",
    mood_good: "Bien",
    mood_great: "Genial",
    mood_note_placeholder: "¿Qué tienes en mente? (opcional)",
    mood_submit: "Registrar y analizar",
    mood_analyzing: "Analizando...",
    mood_logged: "Ánimo registrado",
    mood_ai_insight: "Perspectiva IA",
    mood_suggestions: "Sugerencias",
    mood_continue: "Continuar al panel",
    mood_tracker_title: "Seguimiento de ánimo",
    mood_tracker_subtitle: "Tu viaje de bienestar emocional",
    mood_avg: "Ánimo prom.",
    mood_total_checkins: "Registros totales",
    mood_streak: "Racha",
    mood_top_mood: "Ánimo frecuente",
    mood_distribution: "Distribución de ánimo",
    mood_recent: "Registros recientes",
    mood_no_checkins: "Sin registros de ánimo aún. Tu primer registro aparecerá aquí.",
    mood_prev: "Anterior",
    mood_next: "Siguiente",

    // Weekly Report
    mood_weekly_title: "Informe semanal de ánimo",
    mood_weekly_desc: "Recibe cada lunes un resumen generado por IA de tus patrones de ánimo semanales por email.",
    mood_weekly_enabled: "Informe semanal activado",
    mood_weekly_disabled: "Informe semanal desactivado",
    mood_weekly_toggle_on: "Activar informe semanal",
    mood_weekly_toggle_off: "Desactivar informe semanal",
    mood_weekly_preview: "Ver informe",
    mood_weekly_no_data: "¡Aún no hay suficientes datos. Registra tu ánimo diariamente!",

    // Settings
    settings_title: "Ajustes",
    settings_preferences: "Preferencias",
    settings_2fa_title: "Autenticación de dos factores",
    settings_2fa_desc: "Agrega una capa extra de seguridad a tu cuenta usando Google Authenticator.",
    settings_2fa_enabled: "2FA está activado",
    settings_2fa_disabled: "2FA no está activado",
    settings_2fa_setup: "Configurar 2FA",
    settings_2fa_disable: "Desactivar 2FA",
    settings_2fa_scan: "Escanea este código QR con Google Authenticator",
    settings_2fa_enter_code: "Ingresa el código de 6 dígitos de tu app",
    settings_2fa_verify: "Verificar y activar",
    settings_subscription: "Suscripción",
    settings_manage_sub: "Gestionar suscripción",
    settings_connected: "Servicios conectados",
    settings_connect: "Conectar",
    settings_disconnect: "Desconectar",
    settings_connected_desc: "Conecta servicios externos para mejorar tu experiencia con IA",

    // Pricing Page
    pricing_title: "Elige tu plan",
    pricing_subtitle: "Comienza gratis, mejora cuando estés listo",
    pricing_monthly: "Mensual",
    pricing_yearly: "Anual",
    pricing_save: "Ahorra",
    pricing_current: "Plan actual",
    pricing_upgrade: "Mejorar",
    pricing_downgrade: "Bajar",
    pricing_get_started: "Comenzar",
    pricing_per_month: "/mes",
    pricing_per_year: "/año",
    pricing_one_time: "Pago único",
    pricing_popular: "Más popular",
    pricing_free_desc: "Perfecto para empezar",
    pricing_basic_desc: "Para escritores regulares",
    pricing_premium_desc: "Para superación personal seria",
    pricing_lifetime_desc: "Mejor valor a largo plazo",

    // Contact Page
    contact_title: "Contáctanos",
    contact_subtitle: "¡Nos encantaría saber de ti. Envíanos un mensaje!",
    contact_name: "Nombre",
    contact_name_placeholder: "Tu nombre",
    contact_email: "Email",
    contact_email_placeholder: "tu@email.com",
    contact_subject: "Asunto",
    contact_subject_placeholder: "¿De qué se trata?",
    contact_message: "Mensaje",
    contact_message_placeholder: "Cuéntanos lo que piensas...",
    contact_send: "Enviar mensaje",
    contact_sending: "Enviando...",
    contact_success: "¡Mensaje enviado con éxito!",
    contact_error: "Por favor completa todos los campos obligatorios.",
    contact_company: "Liber Nostra d.o.o.",
    contact_address: "Zagreb, Croacia",
    contact_back: "Volver al inicio",

    // Privacy Page
    privacy_title: "Política de Privacidad",
    privacy_last_updated: "Última actualización",
    privacy_intro: "VerbNotes (\"nosotros\", \"nos\" o \"nuestro\") está comprometido con la protección de su privacidad. Esta política explica cómo recopilamos, usamos y protegemos su información.",
    privacy_collect_title: "Información que recopilamos",
    privacy_collect_desc: "Recopilamos la información que proporciona directamente: datos de cuenta (nombre, email), entradas de diario, datos de ánimo, grabaciones de voz y video. También recopilamos automáticamente datos de uso y dispositivo.",
    privacy_use_title: "Cómo usamos su información",
    privacy_use_desc: "Sus datos se utilizan para proporcionar y mejorar nuestros servicios, generar perspectivas impulsadas por IA y personalizar su experiencia. Nunca vendemos sus datos personales a terceros.",
    privacy_security_title: "Seguridad de datos",
    privacy_security_desc: "Implementamos medidas de seguridad estándar de la industria para proteger sus datos, incluyendo cifrado en tránsito y en reposo.",
    privacy_rights_title: "Sus derechos",
    privacy_rights_desc: "Tiene derecho a acceder, corregir o eliminar sus datos personales en cualquier momento. Contáctenos en support@verbnotes.com.",
    privacy_cookies_title: "Cookies",
    privacy_cookies_desc: "Usamos cookies esenciales para autenticación y preferencias. Las cookies de análisis se usan solo con su consentimiento.",
    privacy_contact_title: "Contacto",
    privacy_contact_desc: "Para consultas relacionadas con la privacidad, contáctenos en support@verbnotes.com.",

    // Terms Page
    terms_title: "Términos de Servicio",
    terms_last_updated: "Última actualización",
    terms_intro: "Al usar VerbNotes, acepta estos Términos de Servicio. Por favor, léalos cuidadosamente.",
    terms_use_title: "Uso del servicio",
    terms_use_desc: "VerbNotes proporciona herramientas de diario y bienestar impulsadas por IA. Debe tener al menos 16 años. Es responsable de mantener la confidencialidad de su cuenta.",
    terms_content_title: "Su contenido",
    terms_content_desc: "Usted conserva la propiedad de todo el contenido que crea. Al usar nuestro servicio, nos otorga una licencia limitada para procesar su contenido para análisis de IA.",
    terms_ai_title: "Descargo de responsabilidad de IA",
    terms_ai_desc: "Nuestras funciones de IA proporcionan sugerencias generales de bienestar y no son un sustituto del consejo médico o psicológico profesional.",
    terms_payment_title: "Pagos y suscripciones",
    terms_payment_desc: "Las suscripciones pagas se facturan según el plan elegido. Puede cancelar en cualquier momento. Los reembolsos se manejan caso por caso.",
    terms_termination_title: "Terminación",
    terms_termination_desc: "Podemos suspender o terminar su cuenta por violaciones de estos términos. Puede eliminar su cuenta en cualquier momento.",
    terms_liability_title: "Limitación de responsabilidad",
    terms_liability_desc: "VerbNotes se proporciona \"tal cual\" sin garantías. No somos responsables de daños indirectos, incidentales o consecuentes.",
    terms_changes_title: "Cambios en los términos",
    terms_changes_desc: "Podemos actualizar estos términos de vez en cuando. Le notificaremos de cambios significativos por email o notificación en la app.",

    // Bug Report
    bug_report_title: "Reportar un error",
    bug_report_btn_title: "Reportar un error",
    bug_report_label_title: "Título",
    bug_report_title_placeholder: "Breve resumen del problema",
    bug_report_severity: "Severidad",
    bug_report_description: "Descripción",
    bug_report_desc_placeholder: "¿Qué pasó? ¿Qué esperabas?",
    bug_report_steps: "Pasos para reproducir (opcional)",
    bug_report_steps_placeholder: "1. Ir a...\n2. Hacer clic en...\n3. Ver error",
    bug_report_submit: "Enviar reporte",
    bug_report_submitted: "Reporte enviado",
    bug_report_thanks: "¡Gracias! Lo investigaremos.",
    bug_report_screenshot: "Captura de pantalla (opcional)",
    bug_report_screenshot_upload: "Subir captura",
    bug_report_screenshot_take: "Tomar captura",
    bug_severity_low: "Bajo",
    bug_severity_medium: "Medio",
    bug_severity_high: "Alto",
    bug_severity_critical: "Crítico",

    // Common
    common_loading: "Cargando...",
    common_save: "Guardar",
    common_cancel: "Cancelar",
    common_delete: "Eliminar",
    common_edit: "Editar",
    common_close: "Cerrar",
    common_search: "Buscar",
    common_back: "Atrás",
    common_next: "Siguiente",
    common_prev: "Anterior",
    common_submit: "Enviar",
    common_yes: "Sí",
    common_no: "No",
  },
};

export default translations;
